import clsx from 'clsx';
import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import FancyTitle from '../fancy-title';
import Container from '../Container';

export default function Headlines({ blok }) {
  const styles = clsx('blok-headlines');
  const headlineRef = React.useRef(null);
  const [hasDarkBackground, setHasDarkBackground] = React.useState(false);

  React.useEffect(() => {
    if (headlineRef.current) {
      let parent = headlineRef.current.parentElement;
      while (parent) {
        if (parent.classList.contains('dark')) {
          setHasDarkBackground(true);
          break;
        }
        parent = parent.parentElement;
      }
    }
  }, []);

  let headlineLevel = blok.headline_level ? blok.headline_level.toLowerCase() : 'h3';
  if (!headlineLevel.startsWith('h')) {
    headlineLevel = `h${headlineLevel}`;
  }
  const shouldHaveMargin = headlineLevel === 'h1' || headlineLevel === 'h3' || headlineLevel === 'h2';
  const Wrapper = blok.use_container ? Container : React.Fragment;

  return (
    <div {...storyblokEditable(blok)} className={styles} ref={headlineRef}>
      <Wrapper>
        <FancyTitle
          text={blok.headline}
          className={`${blok.text_align} ${shouldHaveMargin && 'mb-20'}`}
          tag={headlineLevel}
          subtitle={blok.subline}
          subtitleColor={hasDarkBackground ? 'green' : 'green-dark'}
          marginBottom="0"
          fontSize={blok.font_size || 'lg:text-5xl'}
        />
      </Wrapper>
    </div>
  );
}
